// src/components/LogoSection.js
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/Srn-logo.png'; // Adjust the path to your logo image

const LogoSection = () => {
  return (
    <div className="container d-flex align-items-center">
      <Link to="/" className="d-flex align-items-center">
        <img src={logo} width="125" height="125" alt="SRN Matriculation School" />
        <div className="ml-3">
          <span className="navbar-brand fs-2 font-weight-bold">
          SRN Matriculation School
          </span>
         
        </div>
      </Link>
    </div>
  );
};

export default LogoSection;
